import { LogOut, UserRound } from 'lucide-react';
import type { Me } from '@/api/types';
import { useAuth } from '@/auth/AuthProvider';
import { Button } from '@/components/ui/button';
import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuItem,
  DropdownMenuLabel,
  DropdownMenuSeparator,
  DropdownMenuTrigger,
} from '@/components/ui/dropdown-menu';

export function UserMenu({ me }: { me?: Me }) {
  const { actorLabel, signOut, mode } = useAuth();
  const name = me?.displayName ?? actorLabel ?? 'Signed in';
  const scopes = me?.roles.filter((r) => r.scopeName).map((r) => `${r.role} · ${r.scopeName}`) ?? [];
  const globals = me?.roles.filter((r) => !r.scopeName).map((r) => r.role) ?? [];

  return (
    <DropdownMenu>
      <DropdownMenuTrigger
        render={
          <Button variant="ghost" size="sm" className="gap-2">
            <UserRound className="h-4 w-4" aria-hidden />
            <span className="max-w-[12rem] truncate">{name}</span>
          </Button>
        }
      />
      <DropdownMenuContent align="end" className="w-64">
        <DropdownMenuLabel>
          <span className="block truncate">{name}</span>
          {me?.email ? <span className="id-mono block truncate text-xs text-muted-foreground">{me.email}</span> : null}
        </DropdownMenuLabel>
        <DropdownMenuSeparator />
        <div className="px-2 py-1.5 text-xs text-muted-foreground">
          {globals.length > 0 ? <p>{globals.join(' · ')}</p> : null}
          {scopes.map((s) => (
            <p key={s} className="truncate">
              {s}
            </p>
          ))}
          {globals.length === 0 && scopes.length === 0 ? <p>No roles assigned yet</p> : null}
          <p className="mt-1">
            Sign-in mode: <span className="id-mono">{mode}</span>
          </p>
        </div>
        <DropdownMenuSeparator />
        <DropdownMenuItem onClick={signOut}>
          <LogOut className="mr-2 h-4 w-4" aria-hidden />
          {mode === 'dev' ? 'Switch seeded user' : 'Sign out'}
        </DropdownMenuItem>
      </DropdownMenuContent>
    </DropdownMenu>
  );
}
